import React from "react"

export function handleStickyBoxOverlap(e: React.FocusEvent<HTMLElement>) {
    // avoid unnecessary scroll by checking if the element is overlapped by sticky box
    const stickyBox = document.querySelector("#explicit-fbk-page-sticky-box")
    if (stickyBox) {
        const elementRect = e.currentTarget.getBoundingClientRect()
        const topDiff = stickyBox.getBoundingClientRect().top - elementRect.top
        if (topDiff < elementRect.height) {
            window.scrollBy(0, elementRect.height - topDiff)
        }
    }
}
